<template>
  <v-autocomplete
    v-model="value"
    :items="values"
    :disabled="disabled"
    item-text="name"
    item-value="id"
    return-object
    hide-details
    :dense="hideLabel"
    v-bind="labelProps"
    :class="{ 'ap__no-label': hideLabel }"
  />
</template>

<script>
import VueTypes from "vue-types";
import { ItemState } from "@/modules/redactor/models/item/core/ItemState";

export default {
  name: "r-item-state-dropdown",
  props: {
    model: VueTypes.instanceOf(ItemState),
    label: VueTypes.string.def("State:"),
    disabled: VueTypes.bool.def(false),
    hideLabel: VueTypes.bool.def(false),
  },
  computed: {
    value: {
      get() { return this.model; },
      set(v) { this.$emit("update:model", v); }
    },
    values() {
      return ItemState.getValues();
    },
    labelProps() {
      const has = this.label && this.label.trim().length > 0 && !this.hideLabel;
      return has ? { label: this.label } : {};
    }
  }
}
</script>

<style scoped>
.ap__no-label {
  margin: 0;
  padding: 0;
}
</style>
